interface BestPrice {
  partPackagingAllowed?: boolean | null;
  [key: string]: any;
}

export const useQuantityStepperPartials = () => {
  const allowQuantityPartials = (bestPrice?: BestPrice | null): boolean => {
    return bestPrice?.partPackagingAllowed ?? false;
  };

  return {
    allowQuantityPartials,
  };
};
